// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tabs_wrapper__2iUlu","tabContent":"Tabs_tabContent__23tfV","tabExtraContent":"Tabs_tabExtraContent__3EdGC"};